import { call, takeLatest } from 'redux-saga/effects'

import backendAPI from '../axiosConfig'
import { reportError } from '../features/errorSlice'

const ERROR_ENDPOINT = '/api/error/'

function* reportErrorSaga(action) {
  yield call(() => {
    return backendAPI.post(ERROR_ENDPOINT, action.payload)
  })
}

function* errorAPI() {
  yield takeLatest(reportError.type, reportErrorSaga)
}
export default errorAPI
